<div class="c__medias-content">
  <sd-title [id]="tile.idTitleTile" customClass="brand--h4 is-regular" [titleLevel]="titleLevel">
    {{tile.title}}
  </sd-title>
</div>

<sd-banner
  [mediaTitle]="tile?.mediaTitle"
  [hasAltText]="!tile?.title"
  [media]="tile"
  [videoTitle]="tile?.title"
  [twicPicsAutoSize]="twicPicsAutoSize"
/>

@if (tile.modal) {
  <button sd-button
    type="button"
    icon="icon-plus"
    [isIcon]="true"
    (click)="onOpenModal()"
    [isSmall]="isMobile$"
  >
    <span class="is-visually-hidden">{{'actions.more' | translate}} {{tile.title}}</span>
  </button>
}
